import { render, staticRenderFns } from "./ShortenHours.vue?vue&type=template&id=6132e019&scoped=true&"
import script from "./ShortenHours.vue?vue&type=script&lang=js&"
export * from "./ShortenHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6132e019",
  null
  
)

export default component.exports